import axios from "axios";
import queryString from "query-string";

import { getCookie } from "./cookies";

export const url =
  process.env.NODE_ENV === "production"
    ? "https://api.wms.tradesk.pl"
    : "http://localhost:3002";

// export const url = "http://192.168.10.211:3000";

export const ws_url = "wss://api.wms.tradesk.pl:3334/cable";

export const api_url = `${url}/v1/`;
export const api_url_v2 = `${url}/v2/`;

axios.defaults.headers.common["Authorization"] = getCookie("wms_token");

export const client = axios.create({ baseURL: api_url });
export const client_v2 = axios.create({
  baseURL: api_url_v2,
});

client_v2.interceptors.response.use(
  function (response) {
    return response.data;
  },
  function (error) {
    return Promise.reject(error);
  },
);

export const handleErrors = (data) => {
  try {
    const errors = {};

    data.map(
      ({ detail, source: { pointer } }) =>
        (errors[pointer.split("/")[pointer.split("/").length - 1]] = detail),
    );
    return errors;
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getApiErrorMessage = (error, message = "Wystąpił błąd") => {
  try {
    if (error?.response?.data?.errors?.length > 0) {
      if (typeof error.response.data.errors === "string") {
        return error.response.data.errors;
      }
      return error.response.data.errors.map(({ detail }) => detail).join(", ");
    }
    if (error?.response?.data?.message) {
      return error.response.data.message;
    }
    if (error?.response?.data?.error) {
      return error.response.data.error;
    }
    if (error?.response?.data?.error) {
      return error.response.data.errors.type;
    }
    return message;
  } catch (error) {
    return message;
  }
};

export const parseQuery = (data) =>
  queryString.parse(data, { arrayFormat: "bracket" });

export const stringifyQuery = (data) =>
  queryString.stringify(data, {
    arrayFormat: "bracket",
    skipEmptyString: true,
    skipNull: true,
  });
